module.exports = __webpack_public_path__ + "img/right_md_3.54963c16.jpg";